import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
} from "@material-ui/core";
import { useState } from "react";

export default function FeedbackTable(props) {
  const rows = props.rows;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  return (
    <TableContainer component={Paper}>
      <Table size="small" style={{ tableLayout: "fixed" }} stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Invitation</TableCell>
            <TableCell align="left">Date</TableCell>
            <TableCell align="left">Comment</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row">
                  {row.Invitation}
                </TableCell>
                <TableCell align="left">{row.Date}</TableCell>
                <TableCell align="left">{row.Comment}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TableRow>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
          colSpan={3}
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={(event, page_) => {
            setPage(page_);
          }}
          onChangeRowsPerPage={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </TableRow>
    </TableContainer>
  );
}
